<template lang="html">

  <section class="text-legal pad-sec">
    <div class="container">
      <h3 class="title title-36">YOUR DATA IS SECURE</h3>
      <p class="bold">Information in compliance with the regulation of personal data protection</p>
      <p>In Europe and Spain there are data protection rules designed to protect your personal information that is mandatory for our entity.</p>
      <p>For this reason, it is very important for us that understand perfectly what we are going to do with the personal data we ask for.</p>
      <p>Thus, we will be transparent and we will give you control of your data, with a simple language and clear options that will allow you to decide what we will do with your personal information.</p>
      <p>Please, if after reading this information you have any questions, do not hesitate to ask us.</p>
      <p>Thank you very much for your collaboration</p>
      <p class="bold">Who are we?</p>
      <ul>
        <li>Legal name: <b>AUTO JUNTAS SAU</b></li>

        <li>VAT: <b>A02007029</b></li>

        <li>Main activity: <b>METAL</b></li>

        <li>Our address: <b>Parque Empresarial Ajusa, CM 332, km 2,2, calle 1, número 1., CP 02006, Albacete (Albacete)</b></li>

        <li>Telephone: <b>967-216212</b></li>

        <li>Email: <u><b><a href="mailto:ajusa@ajusa.es">ajusa@ajusa.es</a></b></u></li>

        <li>Web site: www.ajusath.es </li>

      </ul>
      <p>
        For your confidence and security, we inform you that we are an entity registered in the following Commercial Register / Public Registry.
      </p>

      <p>Our main activity is subject to a regime of prior administrative authorization. For your confidence and security, we provide you with the data related to this authorization and the identification of the competent body of our supervision.</p>


      <p class="bold">What are we going to use your data for?</p>
      <p>In general, your personal data will be used to be able to relate to you and be able to provide you with our services.</p>
      <p>Likewise, they can also be used for other activities, such as advertising or promoting our activities.</p> 


      <p class="bold">Why do we need your data?</p>
      <p>Your personal data is necessary to be able to relate to you and be able to provide our services. In this sense, we will put at your disposal a series of boxes that will allow you to decide in a clear and simple way about the use of your personal information.</p>  

      <p class="bold">Who Will know the information we ask?</p>
      <p>In general, only the personnel of our entity that is duly authorized may have knowledge of the information that we request.</p>
      <p>Similarly, may be aware of your personal information those entities that need to have access to it so that we can provide our services. For example, our bank will know your data if the payment of our services is made by card or bank transfer.</p>
      <p>Likewise, your information will be known by public or private entities to which we are obliged to provide your personal data due to compliance with any law. To give you an example, the Tax Law requires to provide the Tax Agency with certain information about economic operations that exceed a certain amount.</p>
      <p>In the event that, regardless of the aforementioned assumptions, we need to disclose your personal information to other entities, we will request your permission in advance through clear options that will allow you to decide in this regard.</p>


      <p class="bold">How are we going to protect your data?</p>
      <p>We will protect your data with effective security measures based on the risks involved in the use of your information.</p>
      <p>For this, our entity has approved a Data Protection Policy and annual controls and audits are carried out to verify that your personal data is safe at all times.</p>

      <p class="bold">Will we send your data to other countries?</p>
      <p>In the world there are countries that are safe for their data and others that are not so secure. For example, the European Union is a secure environment for your data. Our policy is not to send your personal information to any country that is not safe the point of view of protecting your data.
        <p>In the event that, in order to provide the service, it is essential to send your data to a country that is not as safe as Spain, we will always request your permission and apply effective security measures that reduce the risks of sending your information. personal to another country.</p>

        <p class="bold">For how long are we going to keep your data?</p>
        <p>We will keep your data during our relationship and as long as the laws force us. Once the applicable legal deadlines have been finalized, we will proceed to eliminate them in a safe and environmentally friendly manner.</p>

        <p class="bold">What are your data protection rights?</p>
        <p>At any time you can contact us to know what information we have about you, rectify it if it is incorrect and eliminate it once our relationship is finished, in case this is legally possible.</p>
        <p>You also have the right to request the transfer of your information to another entity. This right is called "portability" and may be useful in certain situations.</p>
        <p>To request any of these rights, you must make a written request to our address, along with a photocopy of your ID, to be able to identify you.</p>
        <p>In the offices of our entity we have specific forms to request these rights and we offer our help to complete them.</p>
        <p>To learn more about your data protection rights, you can consult the website of the Spanish Agency for Data Protection (www.agpd.es).</p>

        <p class="bold">Can you withdraw your consent if you change your mind at a later time?</p>
        <p>You can withdraw your consent if you change your mind about the use of your data at any time.</p>
        <p>For example, if you were interested in receiving advertising for our products or services, but no longer wish to receive more publicity, you can let us know through the form of opposition to the treatment available in the offices of our entity.</p>

        <p class="bold">In case you understand that your rights have been neglected, can you file a claim?</p>
        <p>In case you understand that your rights have been ignored by our entity, you can file a claim with the Spanish Agency for Data Protection, through one of the following means:</p>
        <ul>
          <li>Electronic office: www.agpd.es</li>
          <li>Postal address:
          Agencia Española de Protección de Datos C/ Jorge Juan, 6 28001-Madrid </li>
          <li>Telephone::<br>
            Telf. 901 100 099 <br>
            Telf. 91 266 35 17<br>
          </li>
        </ul>

        <p>To file a claim in the Spanish Agency for Data Protection does not entail any cost and the assistance of lawyer or attorney is not necessary.</p>
        <p class="bold">Will we elaborate profiles about you?</p>
        <p>Our policy is not to profiles about the users of our services.
        However, there may be situations in which, for the purpose of providing the service, commercial or otherwise, we need to develop profiles of information about you. An example could be the use of your purchase or service history to be able to offer you products or services adapted to your tastes or needs.</p>
        <p>In this case, we will apply effective security measures that protect your information at all times unauthorized persons who intend to use it for their own benefit.</p>

        <p class="bold">Will we use your data for other purposes?</p>
        <p>Our policy is not to use your data for other purposes than those we have explained to you. If, however, we need to use your data for different activities, we will always request your permission in advance through clear options that will allow you to decide about it.</p>








      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'datos-seguros',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
.datos-seguros {

}
ul li{
  list-style: disc;
  margin-left: 20px;
}
b{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/views/datos-seguros-en.vue